import React from 'react';
import { designBaseUrl } from '../../lib/FL';

import contentCommonStyles from './ContentPreview.module.scss';
import styles from './BukkenListDetailPreview.module.scss';

const BukkenListPc: React.FC = () => (
  <div className={`${contentCommonStyles.content} ${styles.content_pcList}`}>
    <div className={styles.content__search}>
      <img
        className={styles.content__searchImage}
        src={`${designBaseUrl}/assets/formatline/design/pc/common/list_left.png`}
        alt='サンプル画像'
      />
      <img
        className={styles.content__searchButtonImage}
        src={`${designBaseUrl}/assets/formatline/design/pc/common/button_pc.png`}
        alt='この条件で検索'
      />
    </div>
    <div className={styles.content__list}>
      <img
        className={styles.content__listImage}
        src={`${designBaseUrl}/assets/formatline/design/pc/common/list_right.png`}
        alt='サンプル画像'
      />
    </div>
  </div>
);

const BukkenListSp: React.FC = () => (
  <div className={contentCommonStyles.content}>
    <img src={`${designBaseUrl}/assets/formatline/design/sp/common/list.png`} alt='サンプル画像' />
  </div>
);

type Props = {
  device: string;
};

const BukkenListPreview: React.FC<Props> = ({ device }) => (device === 'pc' ? <BukkenListPc /> : <BukkenListSp />);

export default BukkenListPreview;
